export default {
  data() {
    return {
      file: null,
      fileName: "",
      documentName: "",
      xmlHTTP: ""
    };
  },
  methods: {
    onDocFileSelected(file, documentName) {
      this.file = file;
      this.fileName = file.name;
      this.documentName = documentName;
    },
    resetFileState() {
      this.file = null;
      this.fileName = "";
      this.documentName = "";
    }
  }
};
